import { Component } from '@angular/core';

import { AppService } from '../app-service';
import { AsyncPipe } from '@angular/common';

/**
 * This component will show a loading indicator.
 */
@Component({
    selector: 'as-page-loading-indicator',
    templateUrl: './page-loading-indicator.component.html',
    styleUrls: ['./page-loading-indicator.component.scss'],
    standalone: true,
    imports: [AsyncPipe],
})
export class PageLoadingIndicatorComponent {
	/**
	 * Constructor
	 */
	constructor(public app: AppService) {}
}
